import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

import merchantCategoryCode, { MerchantCategoryCode as MCC } from '../../../constants/merchantCategoryCode';
import { Rule } from '../../../utilities/schemas/rules';

type MerchantCategoryCodeBlocklistParam = {
  merchantCategoryCodes: MCC[];
};

const MerchantCategoryCode = ({ rule }: {
  rule: Rule;
}) => (
  <Grid
    alignItems="baseline"
    size={{
      xs: 12,
      sm: 6,
      lg: 4,
    }}
  >
    <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
      <Typography fontWeight="bold" fontSize={10}>
        Blocklisted Merchant Category Codes:
      </Typography>
      <Typography fontSize={10}>
        {(rule.ruleParameters as MerchantCategoryCodeBlocklistParam)
          .merchantCategoryCodes.map((mcc) => `${mcc} - ${merchantCategoryCode[mcc]}`)
          .join(', ')}
      </Typography>
    </Box>
  </Grid>
);

export default MerchantCategoryCode;
